import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import { FILTER_BY, GRAPH_TYPE } from '../../constant'
import {
  getSearchCompany,
  getSearchCompanyForPersonFilter,
  getSearchPerson,
} from './thunk'

const initialState = {
  filter: {
    filterBy: FILTER_BY.COMPANY,
    graphType: GRAPH_TYPE.RADIAL_MAP,
    searchCompany: {},
    searchPerson: {},
    filterPerson: {},
    degree: 1,
  },
  loading: {
    searchCompany: false,
    searchPerson: false,
    searchCompForPersonFilter: false,
    radial: false,
    lbo: false,
    investee: false,
  },
  listCompSearch: [],
  compInfoDetail: {},
  listPersonSearch: [],
  listCompSearchForPersonFilter: [],
  requestIds: {},
  requestCode: null,
}

const slice = createSlice({
  name: 'connectMap/entityMap',
  initialState,
  reducers: {
    changeFilter: (state, action) => {
      state.filter = {
        ...state.filter,
        ...action.payload,
      }
    },
    changeValueSearchPerson: (state, action) => {
      state.filter = {
        ...state.filter,
        searchCompany: {},
        searchPerson: action.payload,
      }
    },
    changeValueSearchCompany: (state, action) => {
      state.filter = {
        ...state.filter,
        searchPerson: {},
        searchCompany: action.payload,
      }
    },
    //redirect from company analysis ownership & group
    changeFilterRadialConnectMap: (state, action) => {
      state.filter = {
        ...initialState.filter,
        searchCompany: action.payload,
      }
    },
    changeListPersonSearch: (state, action) => {
      state.listPersonSearch = action.payload
    },
    resetState: (state) => {
      state.filter = initialState.filter
      state.listCompSearch = initialState.listCompSearch
      state.compInfoDetail = initialState.compInfoDetail
      state.listPersonSearch = initialState.listPersonSearch
      state.listCompSearchForPersonFilter =
        initialState.listCompSearchForPersonFilter
    },
    changeLoading: (state, action) => {
      state.loading = {
        ...state.loading,
        ...action.payload,
      }
    },
    changeRequestId: (state, action) => {
      state.requestIds = {
        ...state.requestIds,
        ...action.payload,
      }
    },
    changeRequestCode: (state, action) => {
      state.requestCode = action.payload
    },
  },
  extraReducers: (builder) => {
    //search company
    builder.addCase(getSearchCompany.pending, (state) => {
      state.loading.searchCompany = true
    })
    builder.addCase(getSearchCompany.fulfilled, (state, action) => {
      state.listCompSearch = action.payload
      state.loading.searchCompany = false
    })
    builder.addCase(getSearchCompany.rejected, (state, action) => {
      state.loading.searchCompany = action.payload.loading
      state.listCompSearch = []
    })

    //search person
    builder.addCase(getSearchPerson.pending, (state) => {
      state.loading.searchPerson = true
      state.listPersonSearch = []
    })
    builder.addCase(getSearchPerson.fulfilled, (state, action) => {
      state.listPersonSearch = action.payload
      state.loading.searchPerson = false
    })
    builder.addCase(getSearchPerson.rejected, (state, action) => {
      state.loading.searchPerson = action.payload.loading
      state.listPersonSearch = []
    })
    //search company for person filter
    builder.addCase(getSearchCompanyForPersonFilter.pending, (state) => {
      state.loading.searchCompForPersonFilter = true
    })
    builder.addCase(
      getSearchCompanyForPersonFilter.fulfilled,
      (state, action) => {
        state.listCompSearchForPersonFilter = action.payload
        state.loading.searchCompForPersonFilter = false
      },
    )
    builder.addCase(
      getSearchCompanyForPersonFilter.rejected,
      (state, action) => {
        state.loading.searchCompForPersonFilter = action.payload.loading
        state.listCompSearchForPersonFilter = []
      },
    )
  },
})

export const selectFilter = (type) => (state) =>
  type ? state[slice.name].filter[type] : state[slice.name].filter
export const selectLoading = (type) => (state) =>
  state[slice.name].loading[type]
export const selectListCompSearch = (state) => state[slice.name].listCompSearch
export const selectListPeronSearch = (state) =>
  state[slice.name].listPersonSearch
export const selectListCompSearchForPersonFilter = (state) =>
  state[slice.name].listCompSearchForPersonFilter
export const selectCompanyInfoDetail = (state) =>
  state[slice.name].compInfoDetail
export const selectRequestIds = (state) => state[slice.name].requestIds
export const selectRequestCode = (state) => state[slice.name].requestCode

export const {
  changeFilter,
  changeFilterRadialConnectMap,
  changeValueSearchPerson,
  changeValueSearchCompany,
  changeListPersonSearch,
  resetState,
  changeLoading,
  changeRequestId,
  changeRequestCode,
} = slice.actions

register(slice.name, slice.reducer)
